/*
 * Public API Surface of app-shared
 */
export * from './modal-utils/modal.service';
export * from './modal-utils/modal/modal.component';
export * from './app-shared.module';
export * from './effects-utils/follow-bar/follow-bar.directive';
